/**
 * HelpNoticeContainer
 * --
 */
import React from 'react';
import HelpNoticePresenter from './HelpNoticePresenter';
import { useDefaultShopDataStack } from 'store';
import Formatter from 'utils/Formatter';

const HelpNoticeContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== Store ===== */
  const { notices } = useDefaultShopDataStack();

  /* ===== STATE ===== */
  const [currentPage, setCurrentPage] = React.useState(1); // 현재 페이지 번호

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 공지사항 목록 정제
   * --
   */
  const Notices = React.useMemo(() => {
    const newNotices = notices
      .slice()
      .sort((a, b) => a.created_at - b.created_at)
      .map((notice, _index) => ({
        id: notice.notice_id,
        no: _index + 1,
        title: notice.notice_name,
        status: '공지',
        created_date: Formatter.unixToDate(notice.created_at, 'YYYY.MM.DD'),
        is_fixed: notice.is_fixed,
      }))
      .sort((a, b) => b.no - a.no);

    const groupNotices = newNotices.reduce(
      (acc, notice) => {
        if (notice.is_fixed === 'Y') {
          acc['fixed'].push(notice);
        }

        acc['list'].push(notice);
        return acc;
      },
      { fixed: [], list: [] }
    );

    return groupNotices;
  }, [notices]);

  /* ===== RENDER ===== */
  return (
    <>
      <HelpNoticePresenter
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        notices={Notices}
        navigate={navigate}
        screenSize={screenSize}
      />
    </>
  );
};

export default HelpNoticeContainer;
